import { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "./api";

const AppConfigCtx = createContext({
  tempo_aceitacao_horas: 1,
  auto_cancel_multiplier: 2,
  dispute_window_hours: 48,
  chat_window_hours_after_complete: 1,
  cancel_fee_pct_before_accept: 0,
  cancel_fee_pct_after_accept: 0.1,
  loaded: false,
});

export function AppConfigProvider({ children }) {
  const [cfg, setCfg] = useState({
    tempo_aceitacao_horas: 1,
    auto_cancel_multiplier: 2,
    dispute_window_hours: 48,
    chat_window_hours_after_complete: 1,
    cancel_fee_pct_before_accept: 0,
    cancel_fee_pct_after_accept: 0.1,
    loaded: false,
  });

  useEffect(() => {
    api.get("/config/public")
      .then((r) => setCfg({ ...r.data, loaded: true }))
      .catch((e) => {
        console.error("[appConfig] failed to load, using defaults:", e?.message);
        setCfg((s) => ({ ...s, loaded: true }));
      });
  }, []);

  const value = useMemo(() => cfg, [cfg]);
  return <AppConfigCtx.Provider value={value}>{children}</AppConfigCtx.Provider>;
}

export const useAppConfig = () => useContext(AppConfigCtx);
